import { render, staticRenderFns } from "./r-panel.vue?vue&type=template&id=01296880"
import script from "./r-panel.vue?vue&type=script&lang=js"
export * from "./r-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01296880')) {
      api.createRecord('01296880', component.options)
    } else {
      api.reload('01296880', component.options)
    }
    module.hot.accept("./r-panel.vue?vue&type=template&id=01296880", function () {
      api.rerender('01296880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/utils/r-panel.vue"
export default component.exports